/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

import React from 'react';

export default function NotFound() {
  return (
    <h1>
      Page Not Found
    </h1>
  )
}
